{
  "processing": "Обробка верифікації...",
  "loadingIframe": "Завантаження верифікації особи...",
  "issueTitle": "Проблема з верифікацією особи",
  "notConfigured": "Верифікацію особи не налаштовано належним чином для цього складу.",
  "notSuccessful": "Верифікація особи не пройшла успішно. Спробуйте знову або зверніться до складу.",
  "couldNotCompleteProceed": "Верифікацію особи не завершено, але ви можете продовжити реєстрацію.",
  "processFailed": "Помилка обробки верифікації особи. Спробуйте знову.",
  "processingFailedProceed": "Обробка верифікації особи не вдалась, але ви можете продовжити реєстрацію.",
  "genericError": "Сталася помилка під час верифікації особи. Спробуйте знову.",
  "issueProceed": "Верифікація особи зіткнулась з проблемою, але ви можете продовжити реєстрацію.",
  "requiredTryAgain": "Верифікація особи необхідна для завершення реєстрації. Спробуйте знову.",
  "checkInFailedTitle": "Не вдалося зареєструватися",
  "checkInFailedMessage": "Не вдалося підтвердити ваш документ"
}
